import sys from '@truckdown/jsclient';

import './Styles/Global.less';

//api services
import * as locations from '@truckdown/locations';

//custom services
import scriptLoader from './Services/ScriptLoader';
import locationUtilities from './Services/LocationsUtilities';
import legacySearchService from './Services/LegacySearchService';
import legacyListingService from './Services/LegacyListingService';

//services

locations.default(sys.framework);

scriptLoader(sys.framework);
locationUtilities(sys.framework);
legacySearchService(sys.framework);
legacyListingService(sys.framework);

//vue components

import lazyImage from "v-lazy-image";
import VueGoogleMaps from '@fawmi/vue-google-maps'

import listingUpdateInfo from './Components/ListingUpdateInfo.vue';
import listingRateService from './Components/ListingRateService.vue';
import listingPreference from './Components/ListingPreference.vue';
import listingNotes from './Components/ListingNotes.vue';
import listingForward from './Components/ListingForward.vue';
import marketingAction from './Components/MarketingAction.vue';

import searchHistory from './Components/SearchHistory.vue';
import serviceHistory from './Components/ServiceHistory.vue';

import searchForm from './Components/SearchForm.vue';
import listingHoursStatusDisplay from './Components/ListingHoursStatusDisplay.vue';
import listingHours from './Components/ListingHours.vue';
import listing from './Components/Listing.vue';

sys.app.component('v-lazy-image', lazyImage);

sys.app.component('listing-update-info', listingUpdateInfo);
sys.app.component('listing-rate-service', listingRateService);
sys.app.component('listing-preference', listingPreference);
sys.app.component('listing-notes', listingNotes);
sys.app.component('listing-forward', listingForward);
sys.app.component('marketing-action', marketingAction);

sys.app.component('search-history', searchHistory);

sys.app.component('search-form', searchForm);
sys.app.component('hours-status-display', listingHoursStatusDisplay);
sys.app.component('listing-hours', listingHours);
sys.app.component('listing', listing);
sys.app.component('service-history', serviceHistory);

sys.app.use(VueGoogleMaps, {
    load: {
        key: sys.framework.context.getSetting('googleMap') ?? '',
        v: 'weekly'
    }
});


//RE-EXPORTS

//components
var components = {
    'v-lazy-image': lazyImage,
    'vue-google-maps': VueGoogleMaps,
    'listing-update-info': listingUpdateInfo,
    'listing-rate-service': listingRateService,
    'listing-prefernece': listingPreference,
    'listing-notes': listingNotes,
    'listing-forward': listingForward,
    'marketing-action': marketingAction,
    'search-form': searchForm,
    'hours-status-display': listingHoursStatusDisplay,
    'listing-hours': listingHours,
    'listing': listing
};
export { components };

//services
export { AddNoteModel } from './Services/AddNoteModel';
export { AddRatingModel } from './Services/AddRatingModel';
export type { ApiResponseModel } from './Services/ApiResponseModel';
export { EditNoteModel } from './Services/EditNoteModel';
export { ForwardLocationModel } from './Services/ForwardLocationModel';
export { HoursOfOperationDisplayType } from './Services/HoursOfOperationDisplayType';
export type { HoursOfOperationDisplayTypeModel } from './Services/HoursOfOperationDisplayTypeModel';
export type { ILegacyListingService } from './Services/ILegacyListingService';
export type { ILegacySearchService } from './Services/ILegacySearchService';
export type { ILocationsUtilities } from './Services/ILocationsUtilities';
export type { IScriptLoader } from './Services/IScriptLoader';
export type { NoteModel } from './Services/NoteModel';
export type { PreferenceModel } from './Services/PreferenceModel';
export type { RatingModel } from './Services/RatingModel';
export type { RatingNoteModel } from './Services/RatingNoteModel';
export type { SearchResultsDataRequest } from './Services/SearchResultsDataRequest';
export { UpdateInfoModel } from './Services/UpdateInfoModel';


//images
export { default as brandedLogo } from './Images/branded.png';

export { default as defaultLogo } from './Images/default.png';
export { default as eliteLogo } from './Images/elite.png';
export { default as preferredLogo } from './Images/preferred.png';
export { default as proLogo } from './Images/pro.png';
export { default as unpublishedLogo } from './Images/unpublished.png';

export { default as type_brand } from './Images/type_brand.png';
export { default as type_pro } from './Images/type_pro.png';
export { default as type_elite } from './Images/type_elite.png';
export { default as type_msp } from './Images/type_msp.png';
export { default as type_mspar } from './Images/type_mspar.png';

export { default as map_search_pin } from './Images/map-pin-search.png';
export { default as defaultPin } from './Images/default-pin.png';
export { default as defaultPreferredPin } from './Images/default-p-pin.png';
export { default as preferredPin } from './Images/preferred-pin.png';
export { default as preferredPreferredPin } from './Images/preferred-p-pin.png';
export { default as elitePin } from './Images/elite-pin.png';
export { default as elitePreferredPin } from './Images/elite-p-pin.png';
export { default as proPin } from './Images/pro-pin.png';
export { default as proPreferredPin } from './Images/pro-p-pin.png';
export { default as brandedPin } from './Images/branded-pin.png';
export { default as brandedPreferredPin } from './Images/branded-p-pin.png';
export { default as mspPin } from './Images/msp-pin.png';
export { default as mspPreferredPin } from './Images/msp-p-pin.png';
export { default as msparPin } from './Images/mspar-pin.png';
export { default as msparPreferredPin } from './Images/mspar-p-pin.png';
export { default as kyrishPin } from './Images/kyrish-pin.png';
export { default as kyrishPreferredPin } from './Images/kyrish-p-pin.png';
export { default as rechtienPin } from './Images/rechtien-pin.png';
export { default as rechtienPreferredPin } from './Images/rechtien-p-pin.png';
export { default as trivistaPin } from './Images/trivista-pin.png';
export { default as trivistaPreferredPin } from './Images/trivista-p-pin.png';
export { default as borderPin } from './Images/border-pin.png';
export { default as borderPreferredPin } from './Images/border-p-pin.png';

export { default as americanexpress } from './Images/americanexpress.png';
export { default as cbcharge } from './Images/cbcharge.png';
export { default as comdata } from './Images/comdata.png';
export { default as discover } from './Images/discover.png';
export { default as efs } from './Images/efs.png';
export { default as mastercard } from './Images/mastercard.png';
export { default as visa } from './Images/visa.png';

//api.locations
export { locations };

